<template>
  <v-row>
    <template>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.inspectionCity"
          :value.sync="cityId"
          :items="citiesByCourtType[courtTypeId]"
          :disabled="!(citiesByCourtType[courtTypeId] || []).length || disabled"
          item-value="id"
          item-text="name"
          :validates="'required'"
          @change="cityChanged"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.lawsuitDetails.court"
          :value="courtId"
          :items="getCourts"
          item-value="id"
          item-text="name"
          :validates="'required'"
          :disabled="disabled"
          @change="updateCourtId"
        ></naj-input>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { caseClassificationEnum } from '@/helpers/enum';
import { isCriminalLawsuit } from '../../../helpers/utils';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapLUTActions, mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'disabled', 'handleGetCourtsInvoker'],
  data() {
    return {
      isCriminalLawsuit,
      cityId: null,
    };
  },
  computed: {
    ...mapState({ caseData: state => state.lawsuitRequest.case }),
    ...mapLUTState(['citiesByCourtType', 'criminalCityCourtByType']),

    courtTypeId() {
      return this.isCriminalLawsuit(this.caseData) ? caseClassificationEnum.criminal : 0;
    },
    getCourts() {
      return this.criminalCityCourtByType[this.cityId] || [];
    },
  },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetCourts(invoker);
    },
    'cityId': function (value) {
      this.$set(this.caseData, 'cityId', value);
    },
    'courtId': function (value) {
      if ((this.getCourts || []).some(x => x.id == value) == false) {
        this.courtId = null;
      }

    },

  },
  mounted() {
    this.cityId = this.caseData.cityId || null;
    this.handleGetCourts('mounted');
  },

  methods: {
    ...mapActions(['']),
    ...mapLUTActions(['getCitiesByCourtType', 'getCriminalCityCourtByType']),

    cityChanged(value) {
      if (value) {
        this.updateCourtId(null);
        if (this.isCriminalLawsuit(this.caseData)) {
          this.getCriminalCityCourtByType(this.cityId)
            .then((cityCourt) => {
              this.updateCourtId((cityCourt || [{ id: null }])[0].id);
            });
        }
      }
    },
    handleGetCourts(invoker) {
      this.getCitiesByCourtType(this.courtTypeId);
      if (this.cityId) {
        if (this.isCriminalLawsuit(this.caseData)) {
          this.getCriminalCityCourtByType(this.cityId);
        }
      }
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
